import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { addIdPrefix } from '../lib/add-id-prefix';
import { getAllRouteParams } from '../lib/get-all-route-params';
import { GalleryService } from './gallery.service';
import { ShareService } from './share.service';

@Injectable({
  providedIn: 'root',
})
export class PublicGalleryService {
  constructor(private galleryService: GalleryService, private shareService: ShareService) {}

  public async getPublicGalleryLink(next: ActivatedRouteSnapshot) {
    const params = getAllRouteParams(next);
    const galleryId = addIdPrefix(params.galleryId, 'gal');
    if (!galleryId) return;
    const assetId = params.assetId;
    try {
      const gallery = await this.galleryService.getGallery(galleryId, { tenant: true, ignore401Errors: true });
      const { url } = await this.shareService.getShareLink(gallery, { assetId });
      return url;
    } catch {}
  }
}
